(function (window, document, $) {
  'use strict';

  if (!$ || !$.fn || !$.fn.slick) return;

  var mobileQuery = window.matchMedia('(max-width: 767px)');
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function slideCount($track) {
    return parseInt($track.attr('data-slide-count'), 10) || $track.find('.makeen-mobile-collection-hero__slide').not('.slick-cloned').length;
  }

  function hydrateSlide($track, index) {
    var count = slideCount($track);
    if (!count) return;

    var normalizedIndex = (index + count) % count;
    var $slide = $track.find('.makeen-mobile-collection-hero__slide[data-mobile-slide-index="' + normalizedIndex + '"]');

    $slide.find('source[data-srcset]').each(function () {
      var $source = $(this);
      $source.attr('srcset', $source.attr('data-srcset'));
      $source.removeAttr('data-srcset');
    });
  }

  function hydrateCurrentAndNext($track, index) {
    hydrateSlide($track, index);
    hydrateSlide($track, index + 1);
  }

  function setUserPaused($shell, paused) {
    var $track = $shell.find('[data-makeen-mobile-hero-track]');
    var $button = $shell.find('[data-makeen-mobile-hero-pause]');

    $shell.toggleClass('is-user-paused', paused).attr('data-user-paused', paused ? 'true' : 'false');
    $button
      .attr('aria-pressed', paused ? 'true' : 'false')
      .attr('aria-label', paused ? 'Diashow abspielen' : 'Diashow pausieren');

    if ($track.hasClass('slick-initialized')) {
      $track.slick(paused ? 'slickPause' : 'slickPlay');
    }
  }

  function initializeCarousel(element) {
    var $shell = $(element);
    var $track = $shell.find('[data-makeen-mobile-hero-track]');

    var initialSlideCount = $track.children('.makeen-mobile-collection-hero__slide').length;
    if (!mobileQuery.matches || $track.hasClass('slick-initialized') || initialSlideCount < 2) return;

    $track.attr('data-slide-count', initialSlideCount);

    var autoplaySpeed = parseInt($shell.attr('data-autoplay-speed'), 10) || 7000;
    var reducedMotion = reducedMotionQuery.matches;
    var autoplay = $shell.attr('data-autoplay') === 'true' && !reducedMotion;
    var $dots = $shell.find('[data-makeen-mobile-hero-dots]');
    var $actions = $shell.find('[data-makeen-mobile-hero-actions]');
    var $pause = $shell.find('[data-makeen-mobile-hero-pause]');

    $shell.css('--makeen-mobile-hero-duration', autoplaySpeed + 'ms');
    hydrateCurrentAndNext($track, 0);

    $track
      .on('beforeChange.makeenMobileHero', function (event, slick, currentSlide, nextSlide) {
        hydrateCurrentAndNext($track, nextSlide);
      })
      .on('afterChange.makeenMobileHero', function () {
        if ($shell.attr('data-user-paused') === 'true') $track.slick('slickPause');
      })
      .slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        fade: true,
        autoplay: autoplay,
        autoplaySpeed: autoplaySpeed,
        speed: reducedMotion ? 1 : 750,
        cssEase: 'cubic-bezier(.22, 1, .36, 1)',
        adaptiveHeight: false,
        pauseOnHover: true,
        pauseOnFocus: true,
        pauseOnDotsHover: true,
        swipe: true,
        touchThreshold: 12,
        accessibility: true,
        arrows: true,
        dots: true,
        appendDots: $dots,
        appendArrows: $actions,
        prevArrow: '<button type="button" class="makeen-mobile-collection-hero__arrow makeen-mobile-collection-hero__arrow--prev" aria-label="Vorherige Kollektion"><svg aria-hidden="true" viewBox="0 0 24 24"><path d="M19 12H6m4-5-5 5 5 5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.7"/></svg></button>',
        nextArrow: '<button type="button" class="makeen-mobile-collection-hero__arrow makeen-mobile-collection-hero__arrow--next" aria-label="Nächste Kollektion"><svg aria-hidden="true" viewBox="0 0 24 24"><path d="M5 12h13m-4-5 5 5-5 5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.7"/></svg></button>',
        customPaging: function (slider, index) {
          var label = $(slider.$slides[index]).attr('data-label') || ('Kollektion ' + (index + 1));
          return '<button type="button" aria-label="' + label + ' anzeigen"><span class="makeen-mobile-collection-hero__dot-rail" aria-hidden="true"></span><span class="makeen-mobile-collection-hero__dot-progress" aria-hidden="true"></span></button>';
        }
      });

    if (autoplay) {
      $pause.prop('hidden', false);
    } else {
      $pause.prop('hidden', true);
      $shell.addClass('is-user-paused');
    }

    $pause.off('.makeenMobileHero').on('click.makeenMobileHero', function () {
      setUserPaused($shell, $shell.attr('data-user-paused') !== 'true');
    });
  }

  function destroyCarousel(element) {
    var $shell = $(element);
    var $track = $shell.find('[data-makeen-mobile-hero-track]');

    if (!$track.hasClass('slick-initialized')) return;

    $track.off('.makeenMobileHero').slick('unslick');
    $shell.find('[data-makeen-mobile-hero-pause]').off('.makeenMobileHero');
    $shell.removeClass('is-user-paused is-visibility-paused').removeAttr('data-user-paused');
  }

  function synchronizeCarousels() {
    $('[data-makeen-mobile-collection-hero]').each(function () {
      if (mobileQuery.matches) initializeCarousel(this);
      else destroyCarousel(this);
    });
  }

  function handleVisibilityChange() {
    $('[data-makeen-mobile-collection-hero]').each(function () {
      var $shell = $(this);
      var $track = $shell.find('[data-makeen-mobile-hero-track]');
      if (!$track.hasClass('slick-initialized')) return;

      if (document.hidden) {
        $shell.addClass('is-visibility-paused');
        $track.slick('slickPause');
      } else {
        $shell.removeClass('is-visibility-paused');
        if ($shell.attr('data-autoplay') === 'true' && $shell.attr('data-user-paused') !== 'true' && !reducedMotionQuery.matches) {
          $track.slick('slickPlay');
        }
      }
    });
  }

  $(synchronizeCarousels);
  $(document).on('shopify:section:load.makeenMobileHero', synchronizeCarousels);
  document.addEventListener('visibilitychange', handleVisibilityChange);

  if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', synchronizeCarousels);
  else mobileQuery.addListener(synchronizeCarousels);

  function handleReducedMotionChange() {
    $('[data-makeen-mobile-collection-hero]').each(function () { destroyCarousel(this); });
    synchronizeCarousels();
  }

  if (reducedMotionQuery.addEventListener) reducedMotionQuery.addEventListener('change', handleReducedMotionChange);
  else reducedMotionQuery.addListener(handleReducedMotionChange);
})(window, document, window.jQuery);
